import { StackSetsDeploymentApiService } from "./service";
import {StackSetsDeployment} from "../../../utils/types/deployments/stacksets/deployment";
import {GenericDeploymentSubmissionResponse} from "../../../utils/types/deployments/genericDeploymentResponse";
import {GenericServiceSummary} from "../../../utils/types/genericServiceSummaryItem";

// Helper function to generate mock data
function generateMockData(): object {

    return {
        "deployments": [
            {
                "commit_id": "mock_commit_id",
                "commit_title": "test commit ",
                "created_at": "1726127870",
                "deployment_status": "COMPLETED",
                "developer_id": "abcd@mock.com",
                "updated_at": "1726128072",
                "changes": [
                    {
                        "id": "mock-id",
                        "created_at": "1726127870",
                        "operation_type": "DELETEINSTANCE",
                        "stackset_id": "mockID",
                        "stackset_status": "COMPLETED",
                        "updated_at": "1726128072",
                        "staggers": [
                            {
                                "created_at": "1726127871",
                                "operation_status": "SUCCEEDED",
                                "operation_type": "DELETEINSTANCE",
                                "stagger_group_name": "mockGroup",
                                "updated_at": "1726128072"
                            }
                        ]
                    }
                ],
                "can_expand": false,
                "can_revert": true
            }
        ]
    }
}

// Updated MockStackSetsDeploymentApiService class
export class MockStackSetsDeploymentApiService implements StackSetsDeploymentApiService {
    async getDeployments(): Promise<StackSetsDeployment[]> {
        const mockData = generateMockData();

        return new Promise<StackSetsDeployment[]>(resolve => {
            setTimeout(() => {
                resolve(StackSetsDeployment.fromJSON(mockData));
            }, 500);
        });
    }

    async deployCommit(changeCase: string, implStepID: string, commitID: string, commitTitle: string, force: boolean, auto: boolean, dryRun: boolean): Promise<GenericDeploymentSubmissionResponse> {
        return new Promise<GenericDeploymentSubmissionResponse>(resolve => {
            setTimeout(() => {
                resolve(new GenericDeploymentSubmissionResponse("Deployment Request Accepted!", true));
            }, 1500);
        });
    }

    async expandCommit(changeCase: string, implStepID: string, commitID: string, commitTitle: string, force: boolean, auto: boolean, dryRun: boolean): Promise<GenericDeploymentSubmissionResponse> {
        return new Promise<GenericDeploymentSubmissionResponse>(resolve => {
            setTimeout(() => {
                resolve(new GenericDeploymentSubmissionResponse("Expand Request Accepted!", true));
            }, 1500);
        });
    }

    async revertCommit(changeCase: string, implStepID: string, commitID: string, commitTitle: string, revertCommitID: string, force: boolean, dryRun: boolean): Promise<GenericDeploymentSubmissionResponse> {
        return new Promise<GenericDeploymentSubmissionResponse>(resolve => {
            setTimeout(() => {
                resolve(new GenericDeploymentSubmissionResponse("Revert Request Accepted!", true));
            }, 1500);
        });
    }
    async getSummary(): Promise<GenericServiceSummary> {
        return new Promise<any>(resolve => {
            setTimeout(() => {
                const summary = GenericServiceSummary.fromJSON({
                    "summaries": [
                        {
                            "status": "Completed",
                            "count": 5
                        },
                        {
                            "status": "In Progress",
                            "count": 5
                        }
                    ]
                })
                resolve(summary);
            }, 1000);
        });
    }
}
